export const Profile = [
  {
    path: '/profile/:app_module_id',
    name: 'profile.index',
    component: () => import('@/pages/Profile/ProfileModule')
  },
  {
    path: '/user/:id',
    name: 'profile.other',
    component: () => import('@/pages/Profile/ProfilePage')
  },
  {
    path: '/profile/:app_module_id/edit',
    name: 'profile.edit',
    component: () => import('@/pages/Profile/ProfileEdit')
  },

  // NETWORKING FEATURES
  {
    path: '/profile/:app_module_id',
    name: 'profile.networking.index',
    component: () => import('@/pages/Profile/NetworkingProfileModule')
  },
  {
    path: '/user/:id',
    name: 'profile.networking.other',
    component: () => import('@/pages/Profile/NetworkingProfilePage')
  },
  {
    path: '/profile/:app_module_id/edit',
    name: 'profile.networking.edit',
    component: () => import('@/pages/Profile/NetworkingProfileEdit')
  }
]
